export const revisionSheetsTranslations = {
  fr: {
    title: "Fiches de révision",
    back: "Retour",
    sheetsCount_one: "{{count}} fiche",
    sheetsCount_other: "{{count}} fiches",
    createSheet: "Créer une fiche",
    create: "Créer",
    search: "Rechercher dans vos fiches...",
    clearSearch: "Effacer",
    sort: "Trier",
    sortNewest: "Plus récentes",
    sortOldest: "Plus anciennes",
    sortAlpha: "Alphabétique",
    resultsCount_one: "{{count}} résultat trouvé",
    resultsCount_other: "{{count}} résultats trouvés",
    noSheets: "Aucune fiche de révision",
    noSheetsMessage: "Commencez votre apprentissage en créant votre première fiche de révision via le chat IA.",
    noSheetsFound: "Aucune fiche trouvée",
    noSheetsSearchMessage: "Essayez d'ajuster votre recherche ou créez une nouvelle fiche.",
    badgeType: "Fiche IA",
    view: "Voir",
    delete: "Supprimer",
    modalTitle: "Fiche de révision",
    loginRequired: "Connexion requise",
    loginMessage: "Connectez-vous pour accéder à vos fiches de révision.",
    loadError: "Erreur lors du chargement des fiches",
    deleteSuccess: "Fiche supprimée avec succès",
    deleteError: "Erreur lors de la suppression",
    confirmDeleteTitle: "Confirmer la suppression",
    confirmDeleteDesc: "Êtes-vous sûr de vouloir supprimer la fiche \"{{title}}\" ? Cette action est irréversible.",
    cancel: "Annuler",
    shareText: "📝 {{title}} — Fiche de révision sur Sclépios IA",
    copied: "Copié !",
    copyContent: "Copier le contenu",
    previous: "Fiche précédente",
    next: "Fiche suivante",
    sections: {
      keyPoints: "Points clés",
      definitions: "Définitions",
      symptoms: "Symptômes",
      diagnosis: "Diagnostic",
      treatment: "Traitement",
      warnings: "Avertissements",
      takeaways: "Points à retenir"
    },
    footer: {
      generated: "Fiche générée automatiquement par l'IA.",
      disclaimer: "Vérifiez toujours les informations avec des sources médicales fiables."
    }
  },
  en: {
    title: "Revision Sheets",
    back: "Back",
    sheetsCount_one: "{{count}} sheet",
    sheetsCount_other: "{{count}} sheets",
    createSheet: "Create sheet",
    create: "Create",
    search: "Search in your sheets...",
    clearSearch: "Clear",
    sort: "Sort",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortAlpha: "Alphabetical",
    resultsCount_one: "{{count}} result found",
    resultsCount_other: "{{count}} results found",
    noSheets: "No revision sheets",
    noSheetsMessage: "Start your learning by creating your first revision sheet via AI chat.",
    noSheetsFound: "No sheets found",
    noSheetsSearchMessage: "Try adjusting your search or create a new sheet.",
    badgeType: "AI Sheet",
    view: "View",
    delete: "Delete",
    modalTitle: "Revision sheet",
    loginRequired: "Login required",
    loginMessage: "Log in to access your revision sheets.",
    loadError: "Error loading sheets",
    deleteSuccess: "Sheet deleted successfully",
    deleteError: "Error deleting sheet",
    confirmDeleteTitle: "Confirm deletion",
    confirmDeleteDesc: "Are you sure you want to delete \"{{title}}\"? This action is irreversible.",
    cancel: "Cancel",
    shareText: "📝 {{title}} — Revision sheet on Sclépios IA",
    copied: "Copied!",
    copyContent: "Copy content",
    previous: "Previous sheet",
    next: "Next sheet",
    sections: {
      keyPoints: "Key Points",
      definitions: "Definitions",
      symptoms: "Symptoms",
      diagnosis: "Diagnosis",
      treatment: "Treatment",
      warnings: "Warnings",
      takeaways: "Key Takeaways"
    },
    footer: {
      generated: "Sheet automatically generated by AI.",
      disclaimer: "Always verify information with reliable medical sources."
    }
  },
  es: {
    title: "Hojas de repaso",
    back: "Volver",
    sheetsCount_one: "{{count}} hoja",
    sheetsCount_other: "{{count}} hojas",
    createSheet: "Crear hoja",
    create: "Crear",
    search: "Buscar en tus hojas...",
    clearSearch: "Borrar",
    sort: "Ordenar",
    sortNewest: "Más recientes",
    sortOldest: "Más antiguas",
    sortAlpha: "Alfabético",
    resultsCount_one: "{{count}} resultado encontrado",
    resultsCount_other: "{{count}} resultados encontrados",
    noSheets: "No hay hojas de repaso",
    noSheetsMessage: "Comienza tu aprendizaje creando tu primera hoja de repaso vía chat IA.",
    noSheetsFound: "No se encontraron hojas",
    noSheetsSearchMessage: "Intenta ajustar tu búsqueda o crea una nueva hoja.",
    badgeType: "Hoja IA",
    view: "Ver",
    delete: "Eliminar",
    modalTitle: "Hoja de repaso",
    loginRequired: "Inicio de sesión requerido",
    loginMessage: "Inicia sesión para acceder a tus hojas de repaso.",
    loadError: "Error cargando hojas",
    deleteSuccess: "Hoja eliminada con éxito",
    deleteError: "Error eliminando hoja",
    confirmDeleteTitle: "Confirmar eliminación",
    confirmDeleteDesc: "¿Estás seguro de que deseas eliminar \"{{title}}\"? Esta acción es irreversible.",
    cancel: "Cancelar",
    shareText: "📝 {{title}} — Hoja de repaso en Sclépios IA",
    copied: "¡Copiado!",
    copyContent: "Copiar contenido",
    previous: "Hoja anterior",
    next: "Hoja siguiente",
    sections: {
      keyPoints: "Puntos clave",
      definitions: "Definiciones",
      symptoms: "Síntomas",
      diagnosis: "Diagnóstico",
      treatment: "Tratamiento",
      warnings: "Advertencias",
      takeaways: "Puntos importantes"
    },
    footer: {
      generated: "Hoja generada automáticamente por IA.",
      disclaimer: "Siempre verifica la información con fuentes médicas confiables."
    }
  }
};
